export default __webpack_public_path__ + "static/media/xsg.3d35e0df.svg";